<app-page-title></app-page-title>
<div class="container-fluid add-business-page p-0">
  <div class="card shadow-none">
    <form #businessForm="ngForm" (ngSubmit)="onSubmit(businessForm)" novalidate>
      <div class="card-body">
        <app-business-form-card [form]="businessForm"/>
      </div>
      <div class="card-footer page-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">ยกเลิก</button>
        <button type="submit" class="btn btn-primary" [disabled]="isSubmitting || isConfirming">
          {{ isSubmitting ? 'กำลังบันทึก...' : (editMode ? 'บันทึกการแก้ไข' : 'ยืนยันบันทึกข้อมูล') }}
        </button>
      </div>
    </form>
  </div>
</div>
